import OpenAI from 'openai';
import { Project } from '../types';

const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
const apiURL = process.env.REACT_APP_OPENAI_API_URL || 'https://api.openai.com/v1';

if (!apiKey) {
  console.warn('OpenAI API key not found in environment variables');
}


const openai = new OpenAI({
  apiKey: apiKey || 'dummy-key',
  dangerouslyAllowBrowser: true,
  baseURL: apiURL
});

export interface ChatMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export const sendMessage = async (messages: ChatMessage[], project: Pick<Project, 'model_name' | 'base_prompt'>) => {
  if (!apiKey) {
    throw new Error('OpenAI API key not found');
  }

  console.log('sendMessage called with project:', {
    model: project.model_name,
    messageCount: messages.length,
    basePromptLength: project.base_prompt?.length ?? 0
  });

  try {
    const systemMessage: ChatMessage = {
      role: 'system',
      content: project.base_prompt || 'You are a helpful assistant.'
    };

    const completion = await openai.chat.completions.create({
      model: project.model_name || 'gpt-4',
      messages: [systemMessage, ...messages],
    });

    console.log('Received response from OpenAI:', {
      status: completion.choices[0].finish_reason,
      responseLength: completion.choices[0].message.content?.length ?? 0
    });

    return completion.choices[0]?.message?.content || 'No response generated';
  } catch (error) {
    console.error('Error calling OpenAI:', error);
    throw error;
  }
};
